/* Las fotos de los sitios se bajan todas al abrir la app con red, de una en una y sin prisa:
   el service worker las guarda (CacheFirst) y luego se ven en modo avión. */
import type { Viaje } from './tipos.ts';

let hecho = false;

export function precargarFotos(v: Viaje) {
  if (hecho || !navigator.onLine || !('serviceWorker' in navigator)) return;
  hecho = true;
  const cola = v.lugares.filter(l => l.foto).map(l => `/api/fotos/${l.foto}`);
  const siguiente = () => {
    const url = cola.shift();
    if (!url) return;
    fetch(url).then(r => { if (r.status === 401) cola.length = 0; }).catch(() => {}).finally(() => setTimeout(siguiente, 150));   // sin sesión, se para
  };
  setTimeout(siguiente, 4000);       // después de pintar lo importante
}
